<ng-container *transloco="let t">
  <ng-container
    *ngFor="let launchdate of productLaunchDates$ | async; trackBy: trackByLaunchDate">
    <ng-container *ngIf="launchdate === 0">
      <popsy-checkbox
        [text]="t('label_all')"
        [mobileMode]="mobile"
        [checked]="getIsLaunchDateSelected(launchdate)"
        (valueChange)="onCheckboxChecked($event, launchdate)"></popsy-checkbox>
    </ng-container>
    <ng-container *ngIf="launchdate !== 0">
      <popsy-checkbox
        [text]="launchdate + ''"
        [mobileMode]="mobile"
        [checked]="getIsLaunchDateSelected(launchdate)"
        (valueChange)="onCheckboxChecked($event, launchdate)"></popsy-checkbox>
    </ng-container>
  </ng-container>
</ng-container>
